export const loginTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
};
